// extracted by mini-css-extract-plugin
module.exports = {"container":"Ecoupons_container__3-2FA","cta":"Ecoupons_cta__2WZ1i"};